var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-drawer",
    {
      attrs: {
        title: "我是标题",
        "custom-class": "My-Community",
        "destroy-on-close": true,
        size: "35%",
        modal: false,
        "append-to-body": true,
        visible: _vm.communityDrawer,
        direction: "rtl",
      },
      on: {
        "update:visible": function ($event) {
          _vm.communityDrawer = $event
        },
      },
    },
    [
      _c("div", { staticClass: "Top" }, [
        _c("div", { staticClass: "T-Left" }, [
          _c("span", [_vm._v(_vm._s(_vm.community.nameCn))]),
          _c("span", [_vm._v(_vm._s(_vm.community.nameEn))]),
        ]),
        _c("div", { staticClass: "T-Right" }, [
          _c("i", {
            staticClass: "el-icon-close",
            on: {
              click: function ($event) {
                _vm.communityDrawer = false
              },
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "Right-End Right-Padding" }, [
        _c(
          "span",
          [
            _c("svg-icon", {
              staticClass: "icon-class",
              attrs: { iconClass: "question" },
            }),
            _vm._v("提问题"),
          ],
          1
        ),
        _c(
          "span",
          [
            _c("svg-icon", {
              staticClass: "icon-class",
              attrs: { iconClass: "pingjia" },
            }),
            _vm._v("写评价"),
          ],
          1
        ),
        _c(
          "span",
          [
            _c("svg-icon", {
              staticClass: "icon-class",
              attrs: { iconClass: "xunjia" },
            }),
            _vm._v("发询价"),
          ],
          1
        ),
      ]),
      _vm.community.productType == 1
        ? _c("ueditor", {
            ref: "ueditor",
            staticClass: "myUeditor",
            attrs: { readonly: true },
          })
        : _vm.community.state == 0
        ? _c("hotelDetail", {
            attrs: { community: _vm.community, checkBudgets: _vm.checkBudgets },
          })
        : _vm.community.state == 2
        ? _c("spotDetail", {
            attrs: { community: _vm.community, checkBudgets: _vm.checkBudgets },
          })
        : _vm.community.state == 1
        ? _c("siteFiyloDetail", {
            attrs: { community: _vm.community, checkBudgets: _vm.checkBudgets },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }